import { Button, Input, InputNumber, message, Modal, Select, Form } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import baseuri from '../../methods/baseuri';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';
import { getBlockchainNetworks } from '../../methods/redux/reducers/currency';

const ModalContent = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 1em;
`;
export const MyButton = styled.button`
	border: none;
	background: transparent;
	display: flex;
	align-items: center;
	cursor: pointer;
	font-size: 12px;
	border-radius: 25px;
	transition: background 400ms ease;
	margin-top: 10px;

	&:hover {
		background: #e2e2e2;
	}
`;
const MyModal = styled(Modal)`
	border-radius: 10px;
	overflow: auto;
`;

interface ICreateCNGNWithdrawal {
	details?: any | null;
}

const CreateCNGNWithdrawal: FC<ICreateCNGNWithdrawal> = ({ details }) => {
	const dispatch = useAppDispatch();
	const [visible, setVisible] = useState(false);
	const [loading, setLoading] = useState(false);
	const [form] = Form.useForm();
	const { blockchains } = useAppSelector((store) => store.currencies);

	useEffect(() => {
		if (blockchains.length < 1) {
			dispatch(getBlockchainNetworks());
		}
	}, []);

	const showModal = () => {
		setVisible(true);
	};

	const handleCancel = () => {
		setVisible(false);
		form.resetFields();
	};

	const handleSubmit = async (values: any) => {
		try {
			setLoading(true);
			const payload = {
				userId: details?.profile?._id,
				amount: values.amount,
				blockchainNetworkId: values.blockchainNetworkId,
				destinationAddress: values.destinationAddress,
				blockchainMemo: values.blockchainMemo || '',
				comment: values.comment,
				code: values.code,
			};
			await baseuri.post('/admin/wallet/trigger-withdrawal/cNGN', payload);
			message.success('cNGN Withdrawal triggered successfully');
			handleCancel();
		} catch (error: any) {
			message.error(error?.response?.data?.message || 'An error occurred');
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<Button onClick={() => setVisible(true)} icon={<SendOutlined />}>
				Trigger cNGN Withdrawal
			</Button>
			<MyModal
				title="Trigger cNGN Withdrawal"
				visible={visible}
				onCancel={handleCancel}
				footer={null}
			>
				<ModalContent>
					<Form form={form} onFinish={handleSubmit} layout="vertical">
						<Form.Item
							name="amount"
							label="Amount"
							rules={[{ required: true, message: 'Please input amount!' }]}
						>
							<InputNumber
								style={{ width: '100%' }}
								placeholder="Enter amount"
								min={0}
							/>
						</Form.Item>

						<Form.Item
							name="blockchainNetworkId"
							label="Blockchain Network"
							rules={[
								{
									required: true,
									message: 'Please select blockchain network!',
								},
							]}
						>
							<Select placeholder="Select blockchain network">
								{blockchains?.map((network: any) => (
									<Select.Option key={network._id} value={network._id}>
										{network.name}
									</Select.Option>
								))}
							</Select>
						</Form.Item>

						<Form.Item
							name="destinationAddress"
							label="Destination Address"
							rules={[
								{
									required: true,
									message: 'Please input destination address!',
								},
							]}
						>
							<Input placeholder="Enter destination address" />
						</Form.Item>

						{/* <Form.Item name="blockchainMemo" label="Blockchain Memo">
							<Input placeholder="Enter blockchain memo (optional)" />
						</Form.Item> */}

						<Form.Item
							name="comment"
							label="Comment"
							rules={[{ required: true, message: 'Please input comment!' }]}
						>
							<Input placeholder="Enter comment" />
						</Form.Item>

						<Form.Item
							name="code"
							label="2fa Code"
							rules={[{ required: true, message: 'Please input 2fa code!' }]}
						>
							<Input placeholder="Enter 2fa code" />
						</Form.Item>

						<Form.Item>
							<Button type="primary" htmlType="submit" loading={loading}>
								{loading ? 'Triggering...' : 'Trigger Withdrawal'}
							</Button>
							<Button onClick={handleCancel} style={{ marginLeft: '8px' }}>
								Cancel
							</Button>
						</Form.Item>
					</Form>
				</ModalContent>
			</MyModal>
		</>
	);
};

export default CreateCNGNWithdrawal;
